import { render, staticRenderFns } from "./CallCentre.vue?vue&type=template&id=2b375f48&scoped=true&"
import script from "./CallCentre.vue?vue&type=script&lang=js&"
export * from "./CallCentre.vue?vue&type=script&lang=js&"
import style0 from "./CallCentre.vue?vue&type=style&index=0&id=2b375f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b375f48",
  null
  
)

export default component.exports